/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { AuthenticationService } from '../../authentication/service/AuthenticationService';
import { PjInjectProxy } from '../../extends_fw/PjInjectProxy';
import { PjBaseController } from '../../extends_fw/controller/PjBaseController';
import { PjServiceResponse } from '../../extends_fw/service/PjServiceResponse';
import { User } from '../../authentication/model/User';

/**
 * システムヘッダの画面領域について出力処理およびイベント処理を行う。
 */
export class HeaderController extends PjBaseController {

    /**
     * ユーザID
     */
    public userid: string;

    /**
     * ユーザ名
     */
    public username: string;

    /**
     * コンストラクタ
     * @param {ng.IWindowService} $window windowサービスの機能
     * @param {ng.ui.bootstrap.IModalService} $uibModal モーダル
     * @param {ng.translate.ITranslateService} $translate angular-templateのサービス
     * @param {PjInjectProxy} pjInjectProxy インジェクタプロキシ
     * @param {AuthenticationService} authenticationService ユーザ認証サービス
     */
    /* @ngInject */
    public constructor(
            protected $window: ng.IWindowService,
            protected $uibModal: ng.ui.bootstrap.IModalService,
            protected $translate: ng.translate.ITranslateService,
            protected pjInjectProxy: PjInjectProxy,
            protected authenticationService: AuthenticationService) {
        super(null, $translate, pjInjectProxy);
        authenticationService.getUser().then((user: PjServiceResponse<User>) => {
            this.userid = user.data.userId;
            this.username = user.data.userName;
        });
    }

    /**
     * 復元処理
     * @param {any} data 復元用データ
     */
    public restore(
            data: any): void {
    }

    /**
     * 表示処理
     */
    public show(): void {
    }

    /**
     * ログアウトイベント
     */
    public logout(): void {
        this.$window.location.href = '../login/index.html#/';
    }

    /**
     * ユーザ情報更新イベント
     */
    public update(): void {
        this.$uibModal.open({
            templateUrl: '../common/extends_fw/template/notice.html',
            controller: 'NoticeDlgController',
            controllerAs : 'Notice',
            resolve : {
                items: ($q: ng.IQService): ng.IPromise<{[id: string]: any}> => {
                    return $q.all([
                        this.$translate('ICS001001T', null, null, null, 'ja'),
                        this.$translate('ICS001001', null, null, null, 'ja')
                    ]);
                }
            }
        }).result.then((result: any) => {

        }).catch(() => {

        });
    }

}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/header/controller/HeaderController.ts
 **/